/* eslint-disable turbo/no-undeclared-env-vars */
import { createTanstackQueryUtils } from '@orpc/tanstack-query'
import * as Sentry from '@sentry/tanstackstart-react'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query'

import ErrorComponent from './components/error-component'
import NotFoundComponent from './components/not-found-component'
import PendingComponent from './components/pending-component'
import { getORPCClient } from './lib/orpc'
import { createQueryClient } from './lib/react-query'
import { routeTree } from './routeTree.gen'

export function getRouter() {
  const queryClient = createQueryClient()

  const orpcClient = getORPCClient()
  const orpc = createTanstackQueryUtils(orpcClient)

  const router = createRouter({
    routeTree,
    context: {
      orpc,
      queryClient
    },
    scrollRestoration: true,
    defaultPreload: 'intent',
    defaultErrorComponent: ErrorComponent,
    defaultViewTransition: true,
    defaultPendingComponent: PendingComponent,
    defaultNotFoundComponent: () => <NotFoundComponent />,
    Wrap: ({ children }) => (
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    )
  })

  if (!router.isServer) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      sendDefaultPii: true,
      enabled: true,
      enableLogs: true,
      tracePropagationTargets: ['localhost', /^https:\/\/api.pesonamalang\.id/],
      tracesSampleRate: 1.0,
      integrations: [
        Sentry.tanstackRouterBrowserTracingIntegration(router),
        Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })
      ],
      environment: import.meta.env.DEV ? 'development' : 'production'
    })
  }

  setupRouterSsrQueryIntegration({
    queryClient,
    router
  })

  return router
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
